<img class="offer-slider-picture  unselectable" *ngIf="offer.pictures[0]" src="{{offer.pictures[0]}}"
     alt="property picture"/>
<div class="offer-info-container">
  <div class="info-left">
    <img class="pin" [src]="'assets/images/pin-maps-' + (offer.isSellable?'sale.png':'rent.png')" alt="">
    <div class="information">
      <div class="top">
        {{offer.subType | translatedb}}, {{offer.space}} кв.м
      </div>
      <div class="bottom">{{offer.area | translatedb}}</div>
    </div>
  </div>
  <div class="info-right">
    {{offerService.getConvertedPrice(offer.price)}}€
  </div>
</div>
<div *ngIf="offer.isSellable && !offer.isAvailable" class="offer-preview-not-free">
  {{ 'SOLD' | translate | uppercase}}
</div>
<div *ngIf="!offer.isSellable && !offer.isAvailable" class="offer-preview-not-free">
  {{ 'RENTED' | translate | uppercase}}
</div>
<a [href]="this.lang + '/offer/' + offer.id.toString()" class="over-link" (click)="navigate($event)" [ngClass]="{'over-link-sold': !offer.isAvailable}"></a>
